import { logEvent } from 'commons/utils/tracking';
import {
  ONBOARDING_RECOMMENDED_PLAN_FREE_CLICK,
  ONBOARDING_RECOMMENDED_PLAN_SCREEN_SHOW,
  ONBOARDING_RECOMMENDED_PLAN_TEST_CLICK,
  ONBOARDING_RECOMMENDED_SEE_OTHER_PLANS_CLICK,
  STORE_CREATION_REGISTRATION_DATA_REDIRECT,
} from 'config/trackingEvents';

export const trackingOnboardingRecommendedPlanScreenShow = (): void => {
  logEvent(ONBOARDING_RECOMMENDED_PLAN_SCREEN_SHOW, {});
};

export const trackingOnboardingRecommendedPlanFreeClick = (): void => {
  logEvent(ONBOARDING_RECOMMENDED_PLAN_FREE_CLICK, {});
};

export const trackingOnboardingRecommendedPlanTestClick = (): void => {
  logEvent(ONBOARDING_RECOMMENDED_PLAN_TEST_CLICK, {});
};

export const trackingOnboardingRecommendedSeeOtherPlansClick = (): void => {
  logEvent(ONBOARDING_RECOMMENDED_SEE_OTHER_PLANS_CLICK, {});
};

export const trackingRedirectToRegistrationPage = (group: string): void => {
  logEvent(STORE_CREATION_REGISTRATION_DATA_REDIRECT, { group });
};
